import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  GET_IDENTIFIERS_PREPAID_SETTINGS,
  convertResult,
} from 'app/common/api/requests/cabinet/identifiers/prepaid/settings'

import { api } from 'app/api'
import type { PrepaidSettings } from 'app/common/components-next/identifiers/data-types/prepaid-settings'

export default function useIdentifiersSettings(studentId: string | number): PrepaidSettings | null {
  const { t } = useTranslation('identifiers-next')

  const [settings, setSettings] = useState<PrepaidSettings | null>(null)

  const request = useCallback(async () => {
    const res = await api.request(GET_IDENTIFIERS_PREPAID_SETTINGS, {
      error: t(
        'identifiers_settings_fetch_error',
        'Не удалось получить данные настроек идентификаторов',
      ) as string,
      params: {
        student_id: studentId,
      },
      convertions: {
        convertResult,
      },
    })

    if (res) {
      setSettings(res)
    }
  }, [studentId, t])

  useEffect(() => {
    request()
  }, [request])

  return settings
}
